import { EnvironmentProviders, Injectable, Provider } from "@angular/core"
import { DashboardRoutesProvider } from "./lib/routes/dashbord.routes"

@Injectable({
    providedIn: 'root',
})
export class DashboardConfigService {
    constructor() {}
}

export const provideDashboard = (): Array<Provider | EnvironmentProviders> => {
    return [
        { provide: DashboardRoutesProvider.getToken(), useClass: DashboardRoutesProvider, multi: true}
    ]
  }